import { render, staticRenderFns } from "./DistSalesProfitCustRpt.vue?vue&type=template&id=5e3b4ebd&scoped=true&"
import script from "./DistSalesProfitCustRpt.vue?vue&type=script&lang=js&"
export * from "./DistSalesProfitCustRpt.vue?vue&type=script&lang=js&"
import style0 from "./DistSalesProfitCustRpt.vue?vue&type=style&index=0&id=5e3b4ebd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3b4ebd",
  null
  
)

export default component.exports